export function dataInRequest(params = {}) {
  return {
    type: '@saldoCotaOrgaoLista/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@saldoCotaOrgaoLista/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@saldoCotaOrgaoLista/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@saldoCotaOrgaoLista/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@saldoCotaOrgaoLista/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@saldoCotaOrgaoLista/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@saldoCotaOrgaoLista/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@saldoCotaOrgaoLista/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@saldoCotaOrgaoLista/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@saldoCotaOrgaoLista/RECORD_FILTERING',
    payload: { params },
  };
}
